import React, { useState } from 'react';
import { Edit2, Plus, Eye, Search } from 'lucide-react';
import { CategoryEditModal } from '../components/CategoryEditModal';
import { Link } from 'react-router-dom';
const categories = [{
  id: 1,
  emoji: '⭐️',
  name: 'Sonho-chave',
  dreamCount: 2847
}, {
  id: 2,
  emoji: '💪',
  name: 'Saúde',
  dreamCount: 1823
}, {
  id: 3,
  emoji: '💼',
  name: 'Carreira',
  dreamCount: 2156
}, {
  id: 4,
  emoji: '✈️',
  name: 'Viagens',
  dreamCount: 1634
}, {
  id: 5,
  emoji: '❤️',
  name: 'Relacionamentos',
  dreamCount: 1289
}];
export function Categories() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState<{
    id: number;
    emoji: string;
    name: string;
  } | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const handleSaveCategory = (emoji: string, name: string) => {
    console.log('Saving category:', {
      emoji,
      name
    });
  };
  const handleNewCategory = () => {
    setEditingCategory(null);
    setIsModalOpen(true);
  };
  const handleEditCategory = (category: (typeof categories)[0]) => {
    setEditingCategory(category);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingCategory(null);
  };
  return <div className="space-y-6" data-id="element-152">
      <div data-id="element-153">
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-154">Categorias Padrão</h1>
        <p className="text-gray-600 mt-1" data-id="element-155">
          Gerencie as categorias sugeridas para novos usuários
        </p>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200" data-id="element-156">
        <div className="p-6 border-b border-gray-200" data-id="element-157">
          <div className="flex items-center justify-between gap-4" data-id="element-158">
            <div className="flex-1 relative" data-id="element-159">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-160" />
              <input type="text" placeholder="Buscar por categoria..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-161" />
            </div>
            <button onClick={handleNewCategory} className="flex items-center gap-2 px-4 py-2 bg-[#8BC4C3] text-white rounded-lg hover:bg-[#6BABA9] transition-colors" data-id="element-162">
              <Plus className="w-5 h-5" data-id="element-163" />
              Nova Categoria
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-164">
          <table className="w-full" data-id="element-165">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-166">
              <tr data-id="element-167">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-168">
                  Emoji
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-169">
                  Nome
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-170">
                  Total de Sonhos
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-171">
                  Porcentagem
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-172">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-173">
              {categories.map(category => {
              const totalDreams = categories.reduce((acc, cat) => acc + cat.dreamCount, 0);
              const percentage = (category.dreamCount / totalDreams * 100).toFixed(1);
              return <tr key={category.id} className="hover:bg-gray-50 transition-colors" data-id="element-174">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-175">
                      <div className="text-3xl" data-id="element-176">{category.emoji}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-177">
                      <span className="text-sm font-medium text-gray-900" data-id="element-178">
                        {category.name}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-179">
                      <span className="text-sm text-gray-600" data-id="element-180">
                        {category.dreamCount.toLocaleString('pt-BR')}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-181">
                      <div className="flex items-center gap-3" data-id="element-182">
                        <div className="flex-1 max-w-xs" data-id="element-183">
                          <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-184">
                            <div className="h-2 rounded-full bg-gradient-to-r from-[#8BC4C3] to-[#2C4A6B] transition-all" style={{
                          width: `${percentage}%`
                        }} data-id="element-185" />
                          </div>
                        </div>
                        <span className="text-sm font-medium text-gray-900 min-w-[3rem]" data-id="element-186">
                          {percentage}%
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-187">
                      <div className="flex items-center gap-2" data-id="element-188">
                        <Link to={`/dreams?category=${category.name}`} className="p-1.5 text-[#2C4A6B] hover:bg-[#E8F4F4] rounded transition-colors" title="Visualizar Sonhos" data-id="element-189">
                          <Eye className="w-4 h-4" data-id="element-190" />
                        </Link>
                        <button onClick={() => handleEditCategory(category)} className="p-1.5 text-[#2C4A6B] hover:bg-[#E8F4F4] rounded transition-colors" title="Editar Categoria" data-id="element-191">
                          <Edit2 className="w-4 h-4" data-id="element-192" />
                        </button>
                      </div>
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between" data-id="element-193">
          <p className="text-sm text-gray-600" data-id="element-194">
            Mostrando 1 a 5 de {categories.length} categorias
          </p>
          <div className="flex gap-2" data-id="element-195">
            <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-196">
              Anterior
            </button>
            <button className="px-3 py-1.5 text-sm bg-[#8BC4C3] text-white rounded-lg" data-id="element-197">
              1
            </button>
            <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-198">
              Próximo
            </button>
          </div>
        </div>
      </div>
      <CategoryEditModal isOpen={isModalOpen} onClose={handleCloseModal} category={editingCategory} onSave={handleSaveCategory} data-id="element-199" />
    </div>;
}